import React from 'react'

import clsx from 'clsx'

import LinearProgress from 'components/LinearProgress'
import Typography from 'components/Typography'
import { kFormatter } from 'helpers/formatters'
import setRatingDistributionValues from 'helpers/setRatingDistributionValues'

import RATINGS from './constants'

import classes from './BreakdownDisplay.module.scss'

/** @type {import('./types').default} */
const RatingBreakdownDisplay = ({ reviewsByRating }) => {
  const linearProgressValues = () => setRatingDistributionValues(reviewsByRating)

  return (
    <div className={clsx('RatingBreakdownDisplay', classes.root)}>
      <div className={classes.numbersColumn}>
        {RATINGS.map(rating => {
          return (
            <Typography
              variant="tight-xxs"
              key={`ratingValue-${rating.toString()}`}
              className={clsx('RatingBreakdownDisplay__NumbersColum', classes.ratingValue)}
            >
              {rating}
            </Typography>
          )
        })}
      </div>
      <div className={classes.linearProgressBarsContainer}>
        {RATINGS.map(rating => {
          return (
            <div
              className={clsx('RatingBreakdownDisplay__LinearProgressBar', classes.linearProgressContainer)}
              key={`ratingValue-${rating.toString()}`}
            >
              <LinearProgress value={linearProgressValues()[rating]} />
            </div>
          )
        })}
      </div>
      <div className={classes.numbersColumn}>
        {RATINGS.map(rating => (
          <Typography
            variant="tight-xxs"
            key={`ratingValue-${rating.toString()}`}
            className={clsx('RatingBreakdownDisplay__NumbersColum', classes.numberOfSpecificReviews)}
          >
            {kFormatter(reviewsByRating[rating])}
          </Typography>
        ))}
      </div>
    </div>
  )
}
export default RatingBreakdownDisplay
